export const firestoreErrorHandler = (error: any) => {
  console.error(error);
};
